/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Dok_S4Inputs */

const en_tut_dok_s4 = /** @type {(inputs: Tut_Dok_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New documents are **Privat**. Switch to **Workspace** if every member may read it, or open **Kelola akses** to invite specific people as **Pembaca** or **Penyunting**.`)
};

const id_tut_dok_s4 = /** @type {(inputs: Tut_Dok_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumen baru bersifat **Privat**. Ubah ke **Workspace** kalau semua anggota boleh membacanya, atau buka **Kelola akses** untuk mengundang orang tertentu sebagai **Pembaca** atau **Penyunting**.`)
};

/**
* | output |
* | --- |
* | "New documents are **Privat**. Switch to **Workspace** if every member may read it, or open **Kelola akses** to invite specific people as **Pembaca** or **Pen..." |
*
* @param {Tut_Dok_S4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_dok_s4 = /** @type {((inputs?: Tut_Dok_S4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Dok_S4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_dok_s4(inputs)
	return en_tut_dok_s4(inputs)
});